'use client';
// RD-20261011 §3-3 — h2 를 읽어 만드는 점프바. 항목을 손으로 넘기지 않는다.
//
// 마운트 후 `rootSelector`(기본 'main') 안의 h2 를 읽는다(우측 레일 aside 안의 h2 는 제외). id 가 없으면 붙인다.
// ⚠️ SSR 에는 바가 없다(클라이언트 생성). G9 의 «점프바 a 수 = h2 수» 는 하이드레이션 뒤 DOM 으로 잰다.
// 모양·sticky 스택은 기존 SiteJumpBar 를 그대로 쓴다(토큰 신설 0). 2개 미만이면 SiteJumpBar 가 null.
// VX-2 REQ_L40 ② — h2 에 `data-jump-label="짧은 말"` 이 있으면 칩 글자로 그 값을 쓴다(없으면 종전대로 textContent).
//   id 는 언제나 h2 «글자» 에서 만든다(속성은 칩 글자만 바꾼다 — 앵커·칩 수 불변).

import React, { useEffect, useState } from 'react';
import SiteJumpBar from '@/components/apt/SiteJumpBar';
import { headingId, jumpItemsFromHeadings, type JumpEntry } from '@/lib/rd/jump';

export default function AutoJumpBar({ rootSelector = 'main' }: { rootSelector?: string }) {
  const [items, setItems] = useState<JumpEntry[]>([]);

  useEffect(() => {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    const taken = new Set<string>(Array.from(root.querySelectorAll('[id]')).map(e => e.id));
    const heads = Array.from(root.querySelectorAll('h2')).filter(h => !h.closest('aside')).map(h => {
      if (!h.id) h.id = headingId(h.textContent || '', taken);
      return { id: h.id, text: h.textContent || '', jumpLabel: h.getAttribute('data-jump-label') };
    });
    setItems(jumpItemsFromHeadings(heads));
  }, [rootSelector]);

  return <SiteJumpBar items={items.map(i => ({ ...i, show: true }))} />;
}
